/**
 * Customized fonts.
 *
 * Reference: https://chakra-ui.com/docs/theming/customize-theme
 */

const fonts = {
  heading: 'Poppins',
  body: 'Poppins'
};

export default fonts;
